import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach Choose-a-plan page — back link, heading, the
// referral-code card, then a row of pricing cards.
export default function CoachPlansSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-10">
                    <Skeleton width={150} height={16} className="mb-6" />
                    <Skeleton width={220} height={32} className="mb-1" />
                    <Skeleton width={320} height={14} className="mb-6" />

                    {/* Referral code card */}
                    <div className={`${cardCls} p-5 mb-8`}>
                        <Skeleton width={160} height={18} className="mb-3" />
                        <Skeleton height={40} borderRadius={12} />
                    </div>

                    {/* Pricing cards */}
                    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div key={i} className={`${cardCls} p-6`}>
                                <Skeleton width={110} height={18} />
                                <Skeleton width={130} height={34} className="mt-3" />
                                <div className="space-y-2 mt-5">
                                    {Array.from({ length: 5 }).map((_, r) => (
                                        <Skeleton key={r} height={13} />
                                    ))}
                                </div>
                                <Skeleton height={42} borderRadius={12} className="mt-6" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
